import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["size", "icon", "isLoading", "classes", "disabled", "avatarRef", "className", "alt", "imgProps", "sizes", "src", "srcSet", "variant", "children"],
  _excluded2 = ["button", "overlay", "progress", "withIcon", "sizeLarge"];
import { Avatar, ButtonBase, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => {
  var sm = theme.breakpoints.up('sm');
  return {
    button: {
      borderRadius: '50%',
      '&[disabled], &[aria-busy="true"]': {
        '& > $overlay': {
          backgroundColor: ColorDynamic.White50
        }
      },
      '&:not([disabled])[aria-busy="false"]': {
        '&:hover, &:focus': {
          '&$withIcon > $overlay': {
            backgroundColor: ColorDynamic.Dark50,
            '& > svg': {
              opacity: 1
            }
          },
          '&:not($withIcon) > $overlay': {
            backgroundColor: ColorDynamic.Black20
          }
        }
      }
    },
    overlay: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      backgroundColor: ColorDynamic.Transparent,
      transition: theme.transitions.create('background-color'),
      '& > svg': {
        opacity: 0,
        color: ColorDynamic.White,
        transition: theme.transitions.create('opacity'),
        fontSize: theme.spacing(3),
        [sm]: {
          fontSize: theme.spacing(2)
        }
      }
    },
    progress: {
      top: 0,
      left: 0,
      position: 'absolute',
      color: ColorDynamic.Blue500,
      fontSize: theme.spacing(5),
      [sm]: {
        fontSize: theme.spacing(4)
      }
    },
    withIcon: {},
    sizeLarge: {
      '& > $root': _objectSpread(_objectSpread({}, theme.typography.h2), {}, {
        width: theme.spacing(7),
        height: theme.spacing(7),
        [sm]: {
          width: theme.spacing(8),
          height: theme.spacing(8)
        }
      }),
      '& > $overlay': {
        '& > $progress': {
          fontSize: theme.spacing(7),
          [sm]: {
            fontSize: theme.spacing(8)
          }
        },
        '& > svg': {
          fontSize: theme.spacing(4),
          [sm]: {
            fontSize: theme.spacing(3)
          }
        }
      }
    },
    root: {},
    colorDefault: {},
    circular: {},
    rounded: {},
    square: {},
    img: {},
    fallback: {}
  };
}, {
  name: 'SD-AvatarButton'
});
export var AvatarButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      size,
      icon,
      isLoading = false,
      classes,
      disabled = false,
      avatarRef,
      className,
      alt,
      imgProps,
      sizes,
      src,
      srcSet,
      variant,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      classes
    }),
    {
      button: buttonClassName,
      overlay: overlayClassName,
      progress: progressClassName,
      withIcon: withIconClassName,
      sizeLarge: sizeLargeClassName
    } = _useStyles,
    avatarClasses = _objectWithoutProperties(_useStyles, _excluded2);
  return /*#__PURE__*/_jsxs(ButtonBase, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    "aria-busy": isLoading,
    "aria-disabled": disabled,
    disabled: disabled || isLoading,
    className: clsx(className, buttonClassName, {
      [withIconClassName]: !!icon,
      [sizeLargeClassName]: size === 'large'
    }),
    children: [/*#__PURE__*/_jsx(Avatar, {
      ref: avatarRef,
      classes: avatarClasses,
      variant: variant,
      alt: alt,
      src: src,
      sizes: sizes,
      srcSet: srcSet,
      imgProps: imgProps,
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: overlayClassName,
      children: [icon, isLoading && /*#__PURE__*/_jsx(CircularProgress, {
        size: "1em",
        className: progressClassName,
        thickness: size === 'large' ? 2.5 : 1.5
      })]
    })]
  }));
});
if (process.env.NODE_ENV !== "production") AvatarButton.displayName = "AvatarButton";